import { IMainMenu, IMainMenuOutput } from '@cardium/contracts';

export function buildMenuForUser(menuItems: IMainMenuOutput[]): IMainMenu[] {
  const rootItems = menuItems.filter((item) => item.partOfId === null);
  const childItems = menuItems.filter((item) => item.partOfId !== null);

  const sortedRootItems = rootItems.sort((a, b) => a.order - b.order);

  return sortedRootItems.map((rootItem) => {
    const children = childItems
      .filter((child) => child.partOfId === rootItem.id)
      .sort((a, b) => a.order - b.order)
      .map((child) => {
        const isAbsoluteUrl = /^(https?|ftp):\/\//.test(child.path);
        const parentPath = rootItem.path;

        // Логика путей
        const finalPath = parentPath && !isAbsoluteUrl
          ? [parentPath, child.path].filter(Boolean).join('/')
          : child.path;

        return {
          id: child.id,
          isGroup: false,
          path: finalPath,
          name: child.name,
          icon: child.icon,
          order: child.order,
        } as IMainMenu; // Явное приведение, если нужно
      });

    const menuItem: IMainMenu = {
      id: rootItem.id,
      isGroup: children.length > 0,
      path: rootItem.path,
      name: rootItem.name,
      icon: rootItem.icon,
      order: rootItem.order,
    } as IMainMenu;

    if (children.length > 0) {
      menuItem.Parts = children as unknown as IMainMenu[];
    }

    return menuItem;
  });
}
